export const districtList = [
  {
    slug: 'quan-7',
    name: 'Quận 7',
  },
  {
    slug: 'huyen-nha-be',
    name: 'Huyện Nhà Bè',
  },
  {
    slug: 'quan-phu-nhuan',
    name: 'Quận Phú Nhuận',
  },
  {
    slug: 'quan-binh-thanh',
    name: 'Quận Bình Thạnh',
  },
]

export const DEFAULT_ITEMS_PER_PAGE = 16
export const DEFAULT_SKIP = 0
export const APP_URL = 'https://ngabds.com'

export const ORDER_BY_TYPES = [
  {
    label: 'Sắp xếp mặc định',
    value: 'default',
  },
  {
    label: 'Giá thấp → cao',
    value: 'price-low',
  },
  {
    label: 'Giá cao → thấp',
    value: 'price-high',
  },
]
